import { useContext } from "react";

import CountersContext from "../context/CountersContext";

const useSupportChat = () => {
  return useContext(CountersContext);
};

export default useSupportChat;
